import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Clear from 'material-ui/svg-icons/content/clear';
import {buttonBlueColor} from "../../utils/utility";
import Select from 'react-select';
import qs from 'qs';

import './invite-user.css';
import { Checkbox } from 'material-ui';

class InviteUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifInviteButtonDisable: true,
      isPrimaryContact: false
    }
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.openInviteUser) {
      setTimeout(() => {
        if (/^(\/clients\/edit\/Business-Units\/detail\/Team Member|\/clients\/edit\/Client-Team-Members)/g.test(nextProps.location.pathname)) {
          if (this.refs.businessUnitName) {
            this.refs.businessUnitName.value = qs.parse(nextProps.location.search.split('?')[1]).name
          }
        }
      },0)
    }
  }

  closeDialog () {
    this.setState({
      isPrimaryContact: false
    })
    this.props.rollbackStatus();
    this.props.closeInviteDialog();

  }

  handleFirstName () {
    this.checkButtonEnable();
  }

  handleLastName () {
    this.checkButtonEnable();
  }
  handleEmail () {
    this.checkButtonEnable();
  }
  handleSendInvite () {
    let isBusinessUnitTeamMember = /^(\/clients\/edit\/Business-Units\/detail\/Team Member|\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname);
    let obj = {
      // roleId: {
      //   id: this.props.rolesValue
      //   name: item[0].label // use the number of value to get labe string.
      // },
      // roleId: isBusinessUnitTeamMember && /^(administrator|team member)/gi.test(this.props.roleName) ? 53 : this.props.rolesValue,
      firstName: this.refs.firstName.value,
      lastName: this.refs.lastName.value,
      email: this.refs.email.value
    }
    if (
      /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) &&
      /^(administrator|team member)/gi.test(this.props.roleName)
    ) {
      obj.roleId = 53;
    } else if (
      /^(\/clients\/edit\/Business-Units\/detail\/Team Member)/g.test(this.props.location.pathname) &&
      /^(system administrator|account manager)/gi.test(this.props.roleName)
    ) {
      obj.roleId = 53;
    } else if (
      /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) &&
      /^(system administrator|account manager)/gi.test(this.props.roleName)
    ) {
      obj.roleId = this.props.rolesValue;
    } else {
      obj.roleId = this.props.rolesValue;
    }
    if (isBusinessUnitTeamMember && this.refs.title.value.length > 0) {
      obj.title = this.refs.title.value; // set title value for bussiness-units/detail/team member router.
    }

    if (this.props.clientId && !isBusinessUnitTeamMember) {
      obj.clientId = parseInt(this.props.clientId, 10)
    } else {
      if (/^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname)) {
        // for administrator invite business team member
        obj.clientId = this.props.match.params.id;
      } else {
        obj.clientId = qs.parse(this.props.location.search.split('?')[1]).id
      }
    }
    
    obj.primaryContact = this.state.isPrimaryContact
    this.props.sendInvite(obj);
  }
  
  inviteAnotherUser () {
    this.setState({
      ifInviteButtonDisable: true
    });
    this.props.rollBackStatus();
    this.refs.firstName.value = '';
    this.refs.lastName.value = '';
    this.refs.email.value = '';
    this.refs.title.value = '';
  }
  checkButtonEnable () {
    let re = /^(([^<>()\\\\.,;:\s@"]+(\.[^<>()\\\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      /^([A-z]{1,}\s?)*[A-z]$/g.test(this.refs.firstName.value) &&
      /^[A-z]+(\s?(-){0,1}\s?[A-z])+$/g.test(this.refs.lastName.value) &&
      re.test(this.refs.email.value)
    ) {
      this.setState({
        ifInviteButtonDisable: false
      })
    } else {
      this.setState({
        ifInviteButtonDisable: true
      })
    }
  }
  handleItemsChange (value) {
   this.props.handleItemsChange(value);
  }
  showRoleField () {
    if (/^\/employees/.test(this.props.location.pathname)) {
      return (
        <Select
          className="iv-role-selector "
          value={this.props.rolesValue}
          clearable={false}
          options={this.props.roles}
          onChange={this.handleItemsChange.bind(this)}
        />
      )
    }
    if (/^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) && /^(system administrator|account manager)/gi.test(this.props.roleName)) {
      return (<Select
        className="iv-role-selector "
        value={this.props.rolesValue}
        clearable={false}
        options={this.props.roles}
        onChange={this.handleItemsChange.bind(this)}
      />)
    }
    if (
      /^\/clients\/edit\/Business-Units\/detail\/Team Members/g.test(this.props.location.pathname) &&
      /^(system administrator|account manager)/gi.test(this.props.roleName)
    ) {
      return (
        <div className="input-border" style={{width: '19em', height: '32px', border: '1px solid black', float: 'right'}}>
          <input disabled={true} type="text" style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="role" value="Business Unit Team Member"/>
        </div>
      )
    }
    if (
      /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname) &&
      /^(administrator|team member)/gi.test(this.props.roleName)
    ) {
      return (
        <div className="input-border" style={{width: '19em', height: '32px', border: '1px solid black', float: 'right'}}>
          <input disabled={true} type="text" style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="role" value="Business Unit Team Member"/>
        </div>
      )
    }
  }
  showTitle () {
    if (this.props.ifSendInviteSuccess) {
      return ""
    } else {
      if (/^\/clients\/edit\/Business-Units\/detail\/Team Member/g.test(this.props.location.pathname)) {
        return 'INVITE BUSINESS UNIT TEAM MEMBER'
      } else if (/^(system administrator|account manager)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname)) {
        return 'INVITE TEAM MEMBER'
      } else if (/^(administrator|team member)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/g.test(this.props.location.pathname)) {
        return 'INVITE BUSINESS UNIT TEAM MEMBER'
      } else {
        return 'INVITE TEAM MEMBER'
      }
    }
  }

  updateIsPrimayContact(){
    this.setState({
      isPrimaryContact: !this.state.isPrimaryContact
    })
  }
  render () {
    return (
      <div className="invite-user">
        <Dialog
          autoDetectWindowHeight={false}
          title={this.showTitle()}
          titleStyle={{fontSize: '18px', border: 'none', marginLeft:"5%", paddingLeft: 0, fontWeight: 'bolder'}}
          open={this.props.openInviteUser}
          contentStyle={{width: this.props.ifSendInviteSuccess ? '40%' : '33%', height: '470px', minWidth:'520px', maxWidth:'520px'}}
          autoScrollBodyContent={true}
        >
          <Clear
            style={{position: 'absolute', right: '1.2em', cursor: 'pointer', top: '1.7em'}}
            onClick={() => this.closeDialog()}
          />

          <div className="form" style={{display: !this.props.ifSendInviteSuccess ? 'block' : 'none'}}>
          <div className="role clearfix" style={{marginBottom: '0.7em'}}>
            <p style={{color: 'black', fontSize: '14px', float: 'left', fontWeight: 'bolder', marginTop: '0.6em'}}>Role</p>
            {
              this.showRoleField()
            }
            </div>
            <div className="common-input clearfix" style={{marginBottom: '0.8em'}}>
              <p style={{color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder'}}>Title</p>
              <div className="input-border" style={{width: '19em', height: '32px', border: '1px solid black', float: 'right'}}>
                <input type="text" style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="title"/>
              </div>
            </div>
            <div className="common-input clearfix" style={{marginBottom: '0.8em'}}>
              <p style={{color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder'}}>First Name<em style={{color: 'red'}}>*</em></p>
              <div className="input-border" style={{width: '19em', height: '32px', border: '1px solid black', float: 'right'}}>
                <input type="text" style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="firstName" onKeyUp={() => this.handleFirstName()}/>
              </div>
            </div>
            <div className="common-input clearfix" style={{marginBottom: '0.8em'}}>
              <p style={{color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder'}}>Last Name<em style={{color: 'red'}}>*</em></p>
              <div className="input-border" style={{width: '19em', height: '32px', border: '1px solid black', float: 'right'}}>
                <input type="text" style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="lastName" onKeyUp={() => this.handleLastName()}/>
              </div>
            </div>
            <div className="common-input clearfix" style={{marginBottom: '0.8em'}}>
              <p style={{color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '0.5em', fontWeight: 'bolder'}}>E-mail<em style={{color: 'red'}}>*</em></p>
              <div className="input-border" style={{width: '19em', height: '32px', border: '1px solid black', float: 'right'}}>
                <input type="text" style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="email" onKeyUp={() => this.handleEmail()}/>
              </div>
            </div>

            {
              /^(\/clients\/edit\/Business-Units\/detail\/Team Member)/g.test(this.props.location.pathname) && (
                <div>
                  <div className="common-input clearfix" style={{marginBottom:'15px', height:'40px'}}>
                    <p style={{color:'#000', fontSize:'14px', marginTop: '0px', fontWeight: 'bolder', position:'absolute' }}>
                      <span>Primay Business <br />Unit Contact</span>
                      <span style={{position:'absolute', top:'5px', right:'-6.2em'}}>
                      <Checkbox iconStyle={{fill:'#000', fillOpacity:'0.7'}} 
                          checked={this.state.isPrimaryContact} onCheck={this.updateIsPrimayContact.bind(this)} />
                      </span>
                    </p>     
                  </div>
                  <div className="common-input clearfix" style={{marginBottom: '0.8em'}}>
                    <p style={{color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '-0.2em', width: '5.7em', fontWeight: 'bolder'}}>Business Unit Name<em style={{color: 'red'}}>*</em></p>
                    <div className="input-border" style={{width:'19em', height: '32px', border: '1px solid black', float: 'right'}}>
                      <input type="text" disabled={true} style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="businessUnitName" onKeyUp={() => this.handleBusinessUnitName()}/>
                    </div>
                  </div>
                </div>
              )
            }
            {
              (
                /^(\/clients\/edit\/Client-Team-Members)/g.test(this.props.location.pathname) &&
                /^(administrator|team member)/gi.test(this.props.roleName)
              ) && (
                <div>
                  <div className="common-input clearfix" style={{marginBottom:'15px', height:'40px'}}>
                    <p style={{color:'#000', fontSize:'14px',  marginTop: '0px', fontWeight: 'bolder', position:'absolute' }}>
                      <span>Primay Business <br />Unit Contact</span>
                      <span style={{position:'absolute', top:'5px', right:'-6.2em'}}>
                        <Checkbox iconStyle={{fill:'#000', fillOpacity:'0.7'}} 
                          checked={this.state.isPrimaryContact} onCheck={this.updateIsPrimayContact.bind(this)} />
                      </span>
                    </p>     
                  </div>
                  <div className="common-input clearfix" style={{marginBottom: '0.8em'}}>
                    <p style={{color: 'black', fontSize: '14px', float: 'left', marginRight: '1em', marginTop: '-0.2em', width: '5.7em', fontWeight: 'bolder'}}>Business Unit Name<em style={{color: 'red'}}>*</em></p>
                    <div className="input-border" style={{width: '19em', height: '32px', border: '1px solid black', float: 'right'}}>
                      <input type="text" disabled={true} style={{border: 'none', height: '30px', width: '98%', paddingLeft: '10px', fontSize: '14px', color: 'black'}} ref="businessUnitName" onKeyUp={() => this.handleBusinessUnitName()}/>
                    </div>
                  </div>
                </div>
              )
            }
            <div className="form-btns clearfix" style={{marginTop:'20px'}}>
              <FlatButton
                label="SEND INVITE"
                style={{fontSize: '13px', color: 'white ', float: 'right'}}
                backgroundColor={buttonBlueColor()}
                hoverColor={buttonBlueColor()}
                onClick={() => this.handleSendInvite()}
                disabled={this.state.ifInviteButtonDisable}
              />
              <a className="btn btn-link pull-right " style={{ marginLeft: '-1.3em', border: '1px solid black', fontWeight: 'bolder', padding: '7px 17px', borderRadius: '0', marginRight: '0.8em', fontSize: '13px'}}
                  onClick={(e) =>  this.closeDialog() } >Cancel</a>
            </div>
            <p style={{color: 'red', textAlign: 'center', fontSize: '12px', marginTop: '1em'}}>
              {this.props.sendInvite_error_message || this.props.send_invitation_error_msg}
              </p>
          </div>

          <div className="invite-user-success" style={{display: this.props.ifSendInviteSuccess ? 'block' : 'none'}}>
            <p style={{fontWeight: 'bolder', color: 'black', textAlign: 'center'}}>Your invitation email has been sent.</p>
            <div className="invite-user-success-btns">
              <a className="btn btn-link" style={{ marginLeft: '-1em', color: 'white', background: buttonBlueColor() }}
                  onClick={(e) => { this.closeDialog() }} >CLOSE</a>
              {/*<FlatButton*/}
                {/*label="INVITE ANOTHER USER"*/}
                {/*style={{fontSize: '14px', color: 'white ', float: 'right'}}*/}
                {/*backgroundColor={buttonBlueColor()}*/}
                {/*onClick={() => this.inviteAnotherUser()}*/}
              {/*/>*/}
            </div>
          </div>
        </Dialog>
      </div>
    )
  }
}

export default InviteUser;



// WEBPACK FOOTER //
// ./src/components/Employees/InviteUser.jsx